"use client";

import Feature3Item from "./Feature3Item";

export default function Feature3ItemsBlock({ slice }) {
  return (
    <div className="flex flex-col lg:flex-row gap-[26px] md:gap-[30px] lg:gap-[38px]">
      {slice.primary?.feature_items.map((item, idx) => {
        return (
          <Feature3Item key={`feature_3_${idx}`} data={item} slice={slice} />
        );
      })}
    </div>
  );
}
